import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'vle-comment-cell-renderer',
  template: `<div>{{ comment }}</div>`,
  styleUrls: ['./comment-cell-renderer.component.scss']
})
export class CommentCellRendererComponent implements ICellRendererAngularComp {
  comment: string;

  agInit({ data }: ICellRendererParams): void {
    this.comment = data.text;
  }

  refresh(): boolean {
    return false;
  }
}
